import "@babel/polyfill";
import "mutationobserver-shim";
import Vue from "vue";
import "./plugins/bootstrap-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import gwzApi from "./plugins/gwzApi";
import gwzAuthCookies from "./plugins/gwzAuthCookies";
import * as VeeValidate from "vee-validate";
import vClickOutside from "v-click-outside";

Vue.config.productionTip = false;
Vue.use(VeeValidate);
Vue.use(gwzAuthCookies);
Vue.use(gwzApi);
Vue.use(vClickOutside);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
